import { useEffect, useState } from 'react';

import {
	Box,
	Heading,
	Table,
	TableContainer,
	Tbody,
	Td,
	Text,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';
import Layout from '../../components/Layout/Layout';
import { getNoticias } from '../../services/noticias';
import { Link } from 'react-router-dom';
import FiltroNoticias from '../../components/Filtros/FiltroNoticias';
import { useCallback } from 'react';
import { useRef } from 'react';

const ListarNoticias = () => {
	const [noticias, setNoticias] = useState([]);

	const [page, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);

	const [filtros, setFiltros] = useState({});

	const loaderRef = useRef(null);

	const loadMoreNoticias = useCallback(
		async (pagina, filtrosABuscar) => {
			if (loading || !hasMore) return;
			setLoading(true);
			try {
				const nuevasNoticias = await getNoticias(
					pagina,
					25,
					filtrosABuscar,
				);
				if (nuevasNoticias.length < 10) setHasMore(false);

				setNoticias(prevNoticias => [
					...prevNoticias,
					...nuevasNoticias,
				]);
				setPage(prevPage => prevPage + 1);
			} catch (error) {
				console.error('Error al cargar más noticias:', error);
				setHasMore(false);
			} finally {
				setLoading(false);
			}
		},
		[hasMore, loading],
	);

	const handleFiltros = ({ target }) => {
		const { value } = target;

		const newFilters = {
			...filtros,
			[target.name]: value,
		};

		setFiltros(newFilters);
		setNoticias([]);
		setPage(1);
		setHasMore(true);
		loadMoreNoticias(1, newFilters);
	};

	useEffect(() => {
		const observer = new IntersectionObserver(
			entries => {
				if (entries[0].isIntersecting && hasMore && !loading) {
					loadMoreNoticias(page, filtros);
				}
			},
			{
				threshold: 1.0,
			},
		);

		const currentLoader = loaderRef.current;
		if (currentLoader) {
			observer.observe(currentLoader);

			return () => {
				if (currentLoader) {
					observer.unobserve(currentLoader);
				}
			};
		}
	}, [hasMore, loading, loadMoreNoticias, page, filtros]);

	// useEffect(() => {
	// 	const getInmuebles = async () => {
	// 		setNeedReload(false);
	// 		const auxInmuebles = await getNoticias();
	// 		setNoticias(auxInmuebles);
	// 	};

	// 	needReload && user && getInmuebles();
	// }, [needReload, user]);

	return (
		<Layout>
			<Box mb={4}>
				<Heading textAlign='center' color='blue.800'>
					NOTICIAS
				</Heading>
			</Box>

			<FiltroNoticias setFiltros={handleFiltros} />

			<Box mt={6}>
				<TableContainer
					w='100%'
					mt={2}
					border='1px'
					borderColor='blue.400'
					rounded='lg'
					shadow='dark-lg'
					overflowX='auto'
					overflowY='auto'
				>
					<Table
						size={{ base: 'sm', md: 'md', lg: 'lg' }}
						variant='simple'
						whiteSpace='nowrap'
					>
						<Thead bgColor='blue.100'>
							<Tr>
								<Th>Noticia</Th>
								<Th>Inmueble</Th>
								<Th>Motivación</Th>
								<Th>Precio cliente</Th>
								<Th>Responsable</Th>
							</Tr>
						</Thead>
						<Tbody>
							{noticias &&
								noticias.map(noticia => {
									let direccion;
									if (
										noticia &&
										noticia.inmueble &&
										noticia.inmueble.ubicacion
									) {
										try {
											direccion = JSON.parse(
												noticia.inmueble.ubicacion,
											).direccion;
										} catch (error) {
											direccion = JSON.parse(
												JSON.stringify(
													noticia.inmueble.ubicacion,
												),
											).direccion;
										}
									}
									return (
										<Tr
											key={noticia.uuid}
											_hover={{
												cursor: 'pointer',
												bg: 'gray.100',
											}}
										>
											<TdLink noticia={noticia.uuid}>
												NT - {noticia.cliente?.nombre}{' '}
												{noticia.cliente?.apellidos} -{' '}
												{noticia.estado}
											</TdLink>
											<TdLink noticia={noticia.uuid}>
												<strong>
													{
														noticia.inmueble
															?.tipo_inmueble
													}{' '}
													{
														noticia.inmueble
															?.subtipo_inmueble
													}
												</strong>{' '}
												en <strong>{direccion}</strong>
											</TdLink>
											<TdLink noticia={noticia.uuid}>
												{noticia.motivacion}
											</TdLink>
											<TdLink noticia={noticia.uuid}>
												{noticia.precio_cliente}
											</TdLink>
											<TdLink noticia={noticia.uuid}>
												{noticia.responsable?.nombre}{' '}
												{noticia.responsable?.apellidos}
											</TdLink>
										</Tr>
									);
								})}
						</Tbody>
					</Table>
				</TableContainer>
				<Box ref={loaderRef} height='40px' />
				{loading && (
					<Text textAlign='center' mt={4}>
						Cargando...
					</Text>
				)}
				{!hasMore && (
					<Text textAlign='center' mt={4}>
						No hay más noticias para mostrar.
					</Text>
				)}
			</Box>
		</Layout>
	);
};

const TdLink = ({ children, noticia }) => {
	return (
		<Td>
			<Link to={`/noticias/ver/${noticia}`}>{children}</Link>
		</Td>
	);
};

export default ListarNoticias;

/*
<Stack direction={["column", "row"]} spacing={4} mb={2}>
                    <Button
                        w="100%"
                        onClick={() => setMostrarTodas(!mostrarTodas)}
                        colorScheme={mostrarTodas ? "blue" : "green"}>
                        {mostrarTodas ? "Mostrar solo las mías" : "Mostrar todas"}
                    </Button>
                    <Button
                        w="100%"
                        onClick={() => setMostrarAbiertas(!mostrarAbiertas)}
                        colorScheme={mostrarAbiertas ? "red" : "green"}>
                        {mostrarAbiertas ? "Mostrar solo las cerradas" : "Mostrar solo las abiertas"}
                    </Button>
                </Stack>
                */
